module.exports = __webpack_public_path__ + "img/tick-not-selected.2b35a2d4.svg";